module.exports = __webpack_public_path__ + "media/images/navigation/gigs-721d6582462e62170e43d608844a5c7e.gif";